import React from 'react';
import { useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../../../components/api';

function useRenderDexData() {
  const [currentPage, setCurrentPage] = React.useState<number>(1);
  const { vmId } = useParams();

  const { data: dexDataRes, isLoading: dexDataLoading } = useQuery(
    ['getDexReading', 'vendingMachines', vmId, currentPage - 1, 10],
    () => api.vendingMachine.getDexReading(vmId!, currentPage - 1, 10),
    {
      enabled: !!vmId,
    },
  );

  const dexData = React.useMemo(() => {
    const resData = dexDataRes?.data;
    return {
      data: resData?.data,
      totalPages: resData?.totalPages ?? 1,
    };
  }, [dexDataRes]);

  return {
    page: {
      current: currentPage,
      setCurrent: setCurrentPage,
    },
    dex: {
      data: dexData.data?.dexCashReading,
      totalPages: dexData.totalPages,
      load: dexDataLoading,
    },
    vmData: dexData.data?.vm,
  };
}

export default useRenderDexData;
